import React from 'react';
import {AppRegistry, Platform} from 'react-native';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import AppNavigation from './App';
import store, {persistor} from './services/redux/store';

export function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppNavigation />
      </PersistGate>
    </Provider>
  );
}

AppRegistry.registerComponent('AroMobileApp', () => App);
if (Platform.OS === 'web') {
  AppRegistry.runApplication('AroMobileApp', {
    rootTag: document.getElementById('root'),
  });
}
